import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../../context/UserContext";
import Loader from "../../../../components/Loader/Loader";
import PaymentModalStep from "../../../PaymentModal/PaymentModalStep";
import ExclusiveMember from "./ExcMemberOnly/ExclusiveMember";
import MembersOnlyGame from "./MemberOnlyGame/MembersOnlyGame";
import BillDetailsModal from "../../BillingComp/BillDetailsModal";

function JoinGame({ onDetailClick }) {
  const { userDetail } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialStep, setInitialStep] = useState(1);
  const [isBillModalOpen, setIsBillModalOpen] = useState(false);

  // Helper function to check if trial is active
  const isTrialActive = () => {
    if (!userDetail?.trial_end_date) return false;
    const today = new Date();
    const [day, month, year] = userDetail.trial_end_date.split("-");
    const trialEndDate = new Date(`${year}-${month}-${day}`);
    if (isNaN(trialEndDate.getTime())) {
      console.error("Invalid Trial End Date:", userDetail.trial_end_date);
      return false;
    }
    return trialEndDate >= today;
  };

  useEffect(() => {
    if (userDetail) {
      // Check if trial is active or payment status is not unpaid
      if (isTrialActive() || userDetail?.payment_status !== "unpaid") {
        setLoading(false);
      } else {
        console.log(userDetail);
        setIsModalOpen(true);
        setLoading(false);
      }
    }
  }, [userDetail]);

  useEffect(() => {
    document.title = `Join Game | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (!userDetail) return;
    const shouldShowModal =
      !userDetail.interested_sports ||
      userDetail.interested_sports.length === 0 ||
      !userDetail.member_work_profile;

    setIsModalOpen(shouldShowModal);
  }, [userDetail]);

  // Handler for "Become a Member Now!" click
  const handleJoinClick = () => {
    setIsModalOpen(true);
    setInitialStep(5);
  };

  // Handler for opening BillDetailsModal from PaymentModalStep
  const handleSecureSpot = () => {
    setIsBillModalOpen(true);
    setIsModalOpen(false);
  };

  // Handler for closing BillDetailsModal
  const handleCloseBillModal = () => {
    setIsBillModalOpen(false);
  };

  const showDashboard = () => {
    if (userDetail?.payment_status === "paid") return true;
    if (
      userDetail?.payment_status === "unpaid" &&
      userDetail?.paid_trial_availed &&
      userDetail?.is_trial_active
    )
      return true;
    return false;
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isModalOpen && (
            <PaymentModalStep
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              initialStep={initialStep}
              onSecureSpot={handleSecureSpot}
            />
          )}
          {isBillModalOpen && (
            <BillDetailsModal onClose={handleCloseBillModal} />
          )}
          {/* {userDetail?.payment_status === "unpaid" && !isTrialActive() ? (
            <ExclusiveMember
              onJoinClick={handleJoinClick}
              userDetail={userDetail}
            />
          ) : (
            <MembersOnlyGame />
          )} */}
          {showDashboard() ? (
            <MembersOnlyGame />
          ) : (
            <ExclusiveMember
              onJoinClick={handleJoinClick}
              userDetail={userDetail}
            />
          )}
        </>
      )}
    </>
  );
}

export default JoinGame;
